export default __webpack_public_path__ + "static/media/org.ad298984.png";